import { Outlet } from "react-router";

export const AuthTemplate = () => {
    return (
        <div className="page_container">
            <div className="page_content">
                <Outlet />
            </div>
        </div>
    );
}